<template lang="pug">
  el-row(id="matching-detail")
    el-col(:span="12").marginTop16
        el-row
        el-col(:span="18")
            .detail-header รายละเอียดงาน
        el-row
        el-col(:span="4")
            .title วันที่ :
        el-col(:span="14")
          el-row(v-for="item in detail.dates", :key="item")
            .detail {{ item }}
        el-row
        el-col(:span="4")
            .title เวร :
        el-col(:span="14")
            .detail {{ detail.shift }}
        el-row
        el-col(:span="4")
            .title ประเภทงาน :
        el-col(:span="14")
            .detail {{ detail.workType }}
        el-row
        el-col(:span="4")
            .title สถานที่ดูแล :
        el-col(:span="14")
            el-row(v-for="item in detail.area", :key="item", style="z-index: 100;")
                .detail(v-if="!item.includes('https://')") {{ item }}
                a.detail(v-if="item.includes('https://')", style="text-decoration: underline", target="_blank", :href="item") ดูแผนที่
        el-row(v-if="detail.care")
        el-col(:span="4", v-if="detail.care")
            .title ผู้ดูแลต้องทำกิจกรรมการดูแลที่โรงพยาบาลหรือไม่ :
        el-col(:span="14", v-if="detail.care")
            .detail {{ detail.care }}
        el-row
        el-col(:span="4")
            .title ประเภทผู้ดูแล :
        el-col(:span="14")
            .detail {{ detail.caregiverTypes }}
        el-row
        el-col(:span="18")
            hr
        el-row
        el-col(:span="18")
            .detail-header ราคาที่จ่ายผู้ดูแล
        el-row
        el-col(:span="10")
            .title ราคาที่จ่ายผู้ดูแล :
        el-col(:span="8")
            .detail.right {{ detail.price }}
        el-row
        el-col(:span="10")
            .title {{ detail.totalShift }}
        el-col(:span="8")
            .detail.right {{ detail.totalPrice }}
        el-row
        el-col(:span="10")
            .title ต่างจังหวัด  :
        el-col(:span="8")
            .detail.right {{ detail.priceZone }}
    el-col(:span="12", style="margin-top: 16px;")
        el-row
        el-col(:span="18")
            .detail-header รายละเอียดการดูแล
        el-row
        el-col(:span="4")
            .title คนไข้ :
        el-col(:span="14")
            .detail {{ detail.patientDetail }}
        el-row
        el-col(:span="4")
            .title ประเภทคนไข้ :
        el-col(:span="14")
            .detail {{ detail.patientType }}
        el-row
        el-col(:span="4")
            .title โรค :
        el-col(:span="14")
            .detail {{ detail.diseases }}
        el-row
        el-col(:span="4")
            .title กิจกรรมใช้ทักษะ :
        el-col(:span="14")
            .detail {{ detail.skills }}
        el-row
        el-col(:span="4")
            .title กิจกรรมทั่วไป :
        el-col(:span="14")
            .detail {{ detail.activity }}
        el-row
        el-col(:span="4")
            .title สิ่งแวดล้อม :
        el-col(:span="14")
            .detail {{ detail.environment }}
        el-row
        el-col(:span="4")
            .title เฝ้าระวังเป็นพิเศษ :
        el-col(:span="14")
            .detail {{ detail.doctorNote }}
        el-row
        el-col(:span="4")
            .title เรื่องอื่น ๆ :
        el-col(:span="14")
            .detail {{ detail.patientNote }}
        el-row
        el-col(:span="4")
            .title แอดมินโน๊ต :
        el-col(:span="14")
            .detail {{ detail.note }}
</template>

<style lang="scss" scoped>
    hr {
        border: 0.5px solid #ebeef5;
        margin: 36px 0 34px 0;
    }
    .el-col > .el-col {
        margin-bottom: 8px;
    }
    .el-col {
        line-height: 1.29;
    }
    .detail-header {
        font-family: 'Sukhumvit-Bold';
        font-size: 16px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 0.63;
        letter-spacing: normal;
        text-align: left;
        color: #606266;
        margin-bottom: 22px;
    }
    .title {
        font-family: 'Sukhumvit-Bold';
        font-size: 14px;
        color: #909399;
        font-weight: bold;
    }

    .detail {
        font-size: 14px;
        font-weight: 500;
        color: #c0c4cc;

      &:hover {
        color: #c0c4cc;
      }
    }

    .right {
        text-align: right;
    }

    .marginTop16 {
        margin-top: 16px;
    }
</style>

<script>
export default {
  name: 'MatchingDetail',
  props: {
    detail: {
      type: Object,
      required: true,
    },
  },
}

</script>
